import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, RequireAuth } from "./context/Auth";
import Layout from "./components/Layout";
import HomePage from "./pages/Home";
import Condition from "./pages/Condition";
import Policy from "./pages/Policy";
import ChildSafety from "./pages/ChildSafety";
// import LoginPage from "./pages/Login";
import NotFoundPage from "./pages/NotFound";
import QRsPage from "./pages/QRs";
import UnauthorizedPage from "./pages/Unauthorized";
import GiftDetail from './pages/GiftDetail';
import OtherProfile from './pages/OtherProfile';


const App = () => {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/login" element={<HomePage />} />
                        <Route path="/politica-de-privacidad/:lang?" element={<Policy />} />
                        <Route path="/condiciones-de-uso/:lang?" element={<Condition />} />
                        <Route path="/politica-seguridad-infantil/:lang?" element={<ChildSafety />} />
                        <Route path="/gift-detail/" element={<GiftDetail />} />
                        <Route path="/gift-detail/:itemId" element={<GiftDetail />} />
                        <Route path="/gift-detail/:itemId/:token" element={<GiftDetail />} />
                        <Route path="/other-profile/" element={<OtherProfile />} />
                        <Route path="/other-profile/:userAlias" element={<OtherProfile />} />
                        <Route path="/other-profile/:userAlias/:token" element={<OtherProfile />} />
                        <Route path="*" element={<NotFoundPage />} />
                        <Route path="/unauthorized" element={<UnauthorizedPage />} />
                        <Route element={<RequireAuth />}>
                            <Route path="/qrs" element={<QRsPage />} />
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
  };
  export default App;
